import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { STATS_SOURCE_LABELS } from '../utils/statsSource.utils';
import type { StatsSource } from '../types/dashboard.types';

interface DashboardSourceSelectProps {
  value?: StatsSource;
  onChange: (source: StatsSource) => void;
}

const SOURCES = Object.keys(STATS_SOURCE_LABELS) as StatsSource[];

export const DashboardSourceSelect: React.FC<DashboardSourceSelectProps> = ({ value, onChange }) => (
  <div className="flex items-center space-x-2">
    <label className="text-sm font-medium text-gray-700">Fuente:</label>
    <Select value={value ?? 'official'} onValueChange={(v) => onChange(v as StatsSource)}>
      <SelectTrigger className="w-48">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {SOURCES.map((source) => (
          <SelectItem key={source} value={source}>
            {STATS_SOURCE_LABELS[source]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
